export const createMarkup = (description) => {
    return {
        __html: description,
    }
}
